const formContainer = document.querySelector(".product-form[data-product]");
const productData = JSON.parse(formContainer.dataset.product);
const productForm = document.querySelector("form[data-type=\"add-to-cart-form\"]");

function updateDiscounts() {
  const selectedVariant = findSelectedVariant();
  const sellingPlanId = document.querySelector('input[name="selling_plan"]:checked').value;
  const availableSellingPlanAllocations = selectedVariant.selling_plan_allocations;
  let price = selectedVariant.price;
  let qty = 1;
  if(availableSellingPlanAllocations && availableSellingPlanAllocations.length > 0 && sellingPlanId) {
    const selectedPlan = availableSellingPlanAllocations.find(plan => plan.selling_plan_id === parseInt(sellingPlanId));
    if(selectedPlan) {
      price = selectedPlan.price;
      qty = selectedPlan.compare_at_price / selectedVariant.price;
    }
  }
  if(price) {
    const discount = ((selectedVariant.compare_at_price * qty) - price) / 100;
    document.querySelector(".discount-box").innerText = 'SAVE ' + new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'QAR',
      minimumFractionDigits: 2,
    }).format(discount);
    document.querySelector(".final-price-item").innerText = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'QAR',
      minimumFractionDigits: 2,
    }).format(price / 100);
    document.querySelector(".compare-price").innerText = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'QAR',
      minimumFractionDigits: 2,
    }).format((selectedVariant.compare_at_price * qty) / 100);
  }
  console.log(sellingPlanId);
  if(sellingPlanId === "3181150436") {
    //b3g2
    document.querySelector(".appstle_subscribe_save_text span.font-light").innerText = '+$15 shipping';
  } else if(sellingPlanId === "3181117668") {
    //b3g2
    document.querySelector(".appstle_subscribe_save_text span.font-light").innerText = '+$10 shipping';
  } else if (sellingPlanId) {
    document.querySelector(".appstle_subscribe_save_text span.font-light").innerText = 'free shipping';
  }
}

const findSelectedVariant = function () {
  const selectedVariantId = parseInt(productForm.querySelector('[name="id"]').value);
  let selectedVariant;
  for (let i = 0; i < productData.variants.length; i++) {
    if (productData.variants[i].id === selectedVariantId) {
      selectedVariant = productData.variants[i];
      break;
    }
  }
  return selectedVariant;
};

productForm.addEventListener('change', function() {
  updateDiscounts();
});

const observer = new MutationObserver(function(mutationsList) {
  for(const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      if(mutation.addedNodes && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if(node.id && node.id.indexOf("appstle") > -1) {
            //selling plans inserted into page
            updateDiscounts();
          }
        });
      }
    }
  }
});
observer.observe(productForm, { childList: true, subtree: true });
setTimeout(function () {
  observer.disconnect();
}, 5000);
